import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, SET_USER_FROM_STORAGE, LOGOUT } from '../../types/login/loginTypes';

const initialState = {
  loading: false,
  user: null,
  error: null,
  authChecking: true,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, loading: true, error: null };
    case LOGIN_SUCCESS:
      return { ...state, loading: false, user: action.payload, error: null };
    case LOGIN_FAILURE:
      return { ...state, loading: false, user: null, error: action.payload };
    case LOGOUT:
      return { ...state, user: null };
    case SET_USER_FROM_STORAGE:
      return {...state,loading:false,user:action.payload,error:null};
    case 'AUTH_CHECK_START':
      return { ...state, authChecking: true };
    case 'AUTH_CHECK_END':
      return { ...state, authChecking: false };
    default:
      return state;
  }
};

export default loginReducer;
